export const countries = [
  {
    id: '4',
    name: 'Турция',
    type: 'country',
    rank: 1,
    visa: false,
    checked: false,
    isUsd: false,
  },
  {
    id: '1',
    name: 'Египет',
    type: 'country',
    rank: 2,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '9',
    name: 'ОАЭ',
    type: 'country',
    rank: 3,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '47',
    name: 'Россия',
    type: 'country',
    rank: 4,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '54',
    name: 'Грузия',
    type: 'country',
    rank: 5,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '13',
    name: 'Китай',
    type: 'country',
    rank: 6,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '16',
    name: 'Вьетнам',
    type: 'country',
    rank: 7,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: 79,
    name: 'Катар',
    type: 'country',
    rank: 8,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '64',
    name: 'Оман',
    type: 'country',
    rank: 9,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '2',
    name: 'Таиланд',
    type: 'country',
    rank: 10,
    visa: false,
    checked: false,
    isUsd: false,
  },
  {
    id: '8',
    name: 'Мальдивы',
    type: 'country',
    rank: 11,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '12',
    name: 'Шри-Ланка',
    rank: 12,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '5',
    name: 'Тунис',
    rank: 13,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '53',
    name: 'Армения',
    type: 'country',
    rank: 14,
    visa: false,
    checked: false,
    isUsd: true,
  },
  {
    id: '55',
    name: 'Азербайджан',
    type: 'country',
    rank: 15,
    visa: false,
    checked: false,
    isUsd: true,
  },
];

// approximate country borders by country id, the search map flies here
// while there are no hotels yet
export const countryBounds = {
  4: { south: 35.8, west: 26, north: 42.1, east: 44.8 },
  1: { south: 22, west: 24.7, north: 31.7, east: 36.9 },
  9: { south: 22.6, west: 51.5, north: 26.1, east: 56.4 },
  47: { south: 41.2, west: 19.6, north: 77.7, east: 180 },
  54: { south: 41.05, west: 40, north: 43.6, east: 46.7 },
  13: { south: 18.2, west: 73.5, north: 53.6, east: 134.8 },
  16: { south: 8.4, west: 102.1, north: 23.4, east: 109.5 },
  79: { south: 24.5, west: 50.75, north: 26.2, east: 51.65 },
  64: { south: 16.6, west: 52, north: 26.4, east: 59.9 },
  2: { south: 5.6, west: 97.3, north: 20.5, east: 105.7 },
  8: { south: -0.7, west: 72.6, north: 7.1, east: 73.8 },
  12: { south: 5.9, west: 79.5, north: 9.9, east: 81.9 },
  5: { south: 30.2, west: 7.5, north: 37.6, east: 11.6 },
  53: { south: 38.8, west: 43.4, north: 41.3, east: 46.6 },
  55: { south: 38.4, west: 44.8, north: 41.9, east: 50.4 },
};

export default countries;
